import { useLocation } from 'react-router-dom';
import http from 'common/http';
import styled from 'styled-components';
import { useEffect, useState } from 'react';

const Page = styled.div`
  background-color: #006edd;
  padding: 0 1rem 1.25rem;
  min-height: 100vh;
  & > header {
    text-align: center;
    margin-bottom: 1rem;
    img {
      width: 14.96rem;
      height: 5.9rem;
    }
    h1 {
      font-size: 1.25rem;
      color: white;
      margin: 0.8rem 0 0.5rem;
    }
    p {
      font-size: 0.88rem;
      color: rgba(255, 255, 255, 0.7);
    }
  }
  & > footer {
    font-size: 0.75rem;
    line-height: 1rem;
    color: white;
  }
`;

const StyledSectionTitle = styled.div`
  text-align: center;
  img {
    width: 1rem;
    height: 1.06rem;
  }
  h2 {
    display: inline-block;
    margin: 0 0.5rem 1rem;
    font-size: 1.13rem;
    color: #333333;
    font-weight: normal;
  }
`;

function SectionTitle(props) {
  return (
    <StyledSectionTitle>
      <img
        src={require('../../assets/images/product_detail_tilte_gutter.png').default}
        alt="gutter"
      />
      <h2>{props.name}</h2>
      <img
        src={require('../../assets/images/product_detail_tilte_gutter.png').default}
        alt="gutter"
      />
    </StyledSectionTitle>
  );
}

const Section = styled.section`
  background-color: white;
  border-radius: 0.31rem;
  padding: 1rem 0 1.25rem;
  margin-bottom: 1rem;

  &.risk > .content {
    padding: 0 1rem;
    .block {
      margin-bottom: 0.6rem;
      &:last-child {
        margin-bottom: 0;
      }
      .title {
        color: white;
        font-size: 0.94rem;
        background-color: #006edd;
        border-top-right-radius: 1rem;
        border-bottom-right-radius: 1rem;
        padding: 0.5rem 1rem;
        margin-left: -1rem;
        display: inline-block;
        margin-bottom: 0.5rem;
      }
      .detail {
        font-size: 0.94rem;
        line-height: 1.5rem;
        color: #666666;
      }
    }
  }

  &.table > .content {
    .item {
      display: flex;
      border-top: solid 1px #e5f0fb;
      padding: 0.5rem 0;
      &:last-child {
        border-bottom: solid 1px #e5f0fb;
      }
      .label {
        font-size: 1rem;
        line-height: 1.5rem;
        color: #006fd6;
        width: 46%;
        padding-left: 1rem;

        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .value {
        font-size: 0.94rem;
        line-height: 1.25rem;
        color: #4d4d4d;
        flex: 1;
        .split-line {
          color: #cccccc;
        }
      }
    }
  }

  &.advice > .content {
    p {
      padding: 0 1rem;
      color: #666666;
      font-size: 0.94rem;
      line-height: 1.5rem;
    }
  }
  &.product > .content {
    & > .item {
      .link {
        margin: 0 1rem;
        padding: 0 0 1rem;
        display: flex;
        align-items: center;
        border-bottom: #f0f0f0 solid 1px;
        .cover {
          width: 6.56rem;
          height: 4.59rem;
          border-radius: 0.19rem;
        }
        .mid {
          flex: 1;
          padding: 0.5rem;
          display: flex;
          flex-direction: column;
          justify-content: center;

          header {
            margin-bottom: 1rem;
            span {
              font-size: 0.94rem;
              color: #666666;
              vertical-align: middle;
            }
            img {
              width: 1.12rem;
              height: 1.12rem;
              vertical-align: middle;
              display: inline-block;
              margin-right: 0.3rem;
            }
          }
        }
        .arrow {
          width: 0.4rem;
          height: 0.65rem;
        }
      }
      .overview {
        padding: 1rem;
        display: flex;
        justify-content: space-between;
        & > .item {
          .label {
            font-size: 0.75rem;
            color: #808080;
            margin-bottom: 0.5rem;
          }
          .value {
            font-size: 1.06rem;
            color: #333333;
          }
        }
      }
      .reason {
        background-color: #fafafa;
        text-align: center;
        padding: 1rem 0;

        .btn-toggle {
          display: inline-block;
          span {
            font-size: 0.88rem;
            line-height: 1.72rem;
            color: #006fd6;
            vertical-align: middle;
          }
          img {
            width: 0.93rem;
            height: 0.93rem;
            vertical-align: middle;
          }
        }
        input[type='checkbox'] {
          display: none;
        }
        input[type='checkbox']:checked ~ p {
          display: none;
        }

        input[type='checkbox']:checked ~ label img {
          transform: rotate(180deg);
        }

        p {
          font-size: 0.75rem;
          line-height: 1.13rem;
          color: #8c8c8c;
          text-align: left;
          padding: 0 1rem;
        }
      }
    }
  }
`;
function Content(props) {
  return (
    <div>
      <Section className="risk">
        <SectionTitle name="风险解读" />
        <div className="content">
          <section className="block">
            <h6 className="title">产品作用</h6>
            <p className="detail">{props.used}</p>
          </section>
          {props.risk && (
            <section className="block">
              <h6 className="title">风险缺口</h6>
              <p className="detail">{props.risk}</p>
            </section>
          )}
        </div>
      </Section>
      <Section className="table">
        <SectionTitle name="投保建议" />
        <div className="content">
          {props.tableList.map((item, index) => (
            <div className="item" key={index}>
              <p className="label">{item.product.name}</p>
              <p className="value">
                保{item.amount}万 <span className="split-line">|</span> {item.insuredTerm}
              </p>
            </div>
          ))}
        </div>
      </Section>
      <Section className="advice">
        <SectionTitle name="核保建议" />
        <div className="content">
          <p>{props.suggest}</p>
        </div>
      </Section>
      <Section className="product">
        <SectionTitle name="搭配产品" />
        <div className="content">
          {props.productList.map((item, index) => (
            <div className="item">
              <div className="link">
                <img
                  className="cover"
                  src={require('../../assets/images/plan_product_default_cover.jpg').default}
                  alt="cover"
                />
                <div className="mid">
                  <header>
                    <img src={require('../../assets/images/icon_brand.png').default} alt="brand" />
                    <span>{item.product.company.companyName}</span>
                  </header>
                  <p>{item.product.name}</p>
                </div>
                <img
                  className="arrow"
                  src={require('../../assets/images/icon_arrow_right.png').default}
                  alt="arrow"
                />
              </div>
              <div className="overview">
                <div className="item">
                  <p className="label">保障额度</p>
                  <p className="value" style={{ color: '#006fd6' }}>
                    {item.amount}万元
                  </p>
                </div>
                <div className="item">
                  <p className="label">保障期限</p>
                  <p className="value">{item.insuredTerm}</p>
                </div>
                <div className="item">
                  <p className="label">保障费用</p>
                  <p className="value">{item.premiums}元/年</p>
                </div>
              </div>
              {item.recommentContent && item.recommentContent.content && (
                <div className="reason">
                  <input id="button" type="checkbox" />
                  <label htmlFor="button" className="btn-toggle">
                    <span>配置理由</span>
                    <img
                      src={require('../../assets/images/icon_up_arrow.png').default}
                      alt="icon"
                    />
                  </label>
                  <p>{item.recommentContent.content}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
}

function Detail() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const [id] = useState(query.get('id'));
  const [data, setData] = useState({});
  const [header, setHeader] = useState({});
  const [tableList, setTableList] = useState([]);
  const [productList, setProductList] = useState([]);

  useEffect(() => {
    http.get(`/getCustomizePlanInfo?id=${id}`).then((res) => {
      let data = res.data.data;
      setData(res.data.data);
      setHeader({
        title: data.dictionaryContent.content,
        desc: data.dictionaryContent.description,
      });
      setTableList(data.planSafetyLs);
      setProductList(data.planSafetyLs);
      console.log('res', res);
    });
  }, [id]);

  return (
    <Page>
      <header>
        <img src={require('../../assets/images/explain_top.png').default} alt="pic" />
        <h1>{header.title}</h1>
        <p>{header.desc}</p>
      </header>
      <Content tableList={tableList} productList={productList} {...data} />
      <footer>
        特别提醒：保险责任仅是对产品的简单介绍，投保人需要认真阅读投保须知、保险条款。投保时，请认真阅读健康问卷要求，做好如实告知。
      </footer>
    </Page>
  );
}

export default Detail;
